import { useContext, useEffect } from "react";
import { NotificationContext } from "../Context/NotificationContext";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer, List } from "antd";
import { useNavigate } from "react-router-dom";
import NotificationService from "../API/NotificationService";
import useNotificationStore from "../Component/State/useNotificationStore";

const NotificationBell = () => {
    const { notifications, refreshNotifications } = useContext(NotificationContext);
    const { isDrawerOpen, toggleDrawer, setDrawerOpen, hasInitialized } = useNotificationStore();
    const navigate = useNavigate();

    useEffect(() => {
        if (!hasInitialized) {
            setDrawerOpen(false);
        }
        refreshNotifications();
    }, []);

    const handleNotificationClick = async (index) => {
        const selectedNotification = notifications[index];
        const response = await NotificationService.UpdateNotification(selectedNotification.notificationId);

        if (response.status) {
            await refreshNotifications();
            setDrawerOpen(false);
            if (selectedNotification?.orderId !== 0) {
                navigate(`/invoice-detail/${selectedNotification.orderId}`);
            }
            else if (selectedNotification?.orderId === 0) {
                navigate(`/customer-detail/${selectedNotification.customerId}`);
            }
        }
    };

    const groupedNotifications = notifications.reduce((groups, notification) => {
        const type = notification.type;
        if (!groups[type]) {
            groups[type] = [];
        }
        groups[type].push(notification);
        return groups;
    }, {});

    const typeIcons = {
        1: <i className="fa-solid fa-box not-icon"
        style={{
            width: "31px",
        }}></i>, // Icon for Orders
        2: <i className="fa-solid fa-credit-card not-icon"
        style={{
            width: "47px",
        }}></i>, // Icon for Payments
        3: <i className="fa-solid fa-comment not-icon"
        style={{
            width: "29px",
        }}></i>, // Icon for New Message
        default: <i className="fa-solid fa-bell not-icon"></i>, // Default icon
    };


    // Map type to display labels
    const typeLabels = {
        1: "Orders",
        2: "Payments",
        3: "New Message",
        default: "",
    };

    return (
        <>
            <div className="circle me-3" onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleDrawer();
            }}>
                <div className="sub-circle position-absolute">
                    {notifications.filter(n => !n.seen).length}
                </div>
                <i className="fa-solid fa-bell bell-icon"></i>
            </div>

            <Drawer
                title="Notifications"
                placement="right"
                closable={true}
                onClose={() => setDrawerOpen(false)}
                open={isDrawerOpen}
                width={400}
                closeIcon={<CloseOutlined />}
                maskClosable={false}
                destroyOnClose={true}
            >

                {Object.keys(groupedNotifications).map((type) => (
                    <div key={type}>
                        <h5 className="add-title-box mt-2 mb-2"
                            style={{ marginLeft: '11px', color: "#222222" }}>{typeLabels[type] || typeLabels.default}</h5>
                        <List
                            dataSource={groupedNotifications[type]}
                            renderItem={(item, index) => (
                                <List.Item
                                    onClick={() => handleNotificationClick(index)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "4px 10px 2px 10px",
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px", // Space between icon and message
                                        }}
                                        className="notification"
                                    >
                                        {typeIcons[item.type] || typeIcons.default}
                                        {item.message}
                                    </span>
                                </List.Item>
                            )}
                        />
                    </div>
                ))}
            </Drawer>
        </>
    );
};

export default NotificationBell;
